<template>
    <div class="vertical-timeline">
        <div class="timeline-line"></div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'TimeLineVertical'
}
</script>

<style scoped>
.vertical-timeline {
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
}

.timeline-line {
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(to bottom,
        transparent 0%,
        rgba(255, 107, 107, 0.3) 10%,
        rgba(255, 107, 107, 0.3) 90%,
        transparent 100%
    );
    transform: translateX(-50%);
    z-index: 0;
}

/* Tablet/móvil: carrusel horizontal deslizable */
@media (max-width: 968px) {
    .vertical-timeline {
        display: flex;
        gap: 16px;
        padding: 10px 0 15px;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        scrollbar-width: thin;
        scrollbar-color: rgba(255, 107, 107, 0.4) transparent;
    }

    .timeline-line {
        display: none;
    }
}
</style>
